import { useUIStore } from '../store/ui';

export default function Toast() {
  const { toast, hideToast } = useUIStore();

  if (!toast) return null;

  const bgColor = {
    success: 'bg-green-500',
    error: 'bg-red-500',
    info: 'bg-tg-theme-button'
  }[toast.type];

  return (
    <div
      className={`fixed top-4 left-4 right-4 ${bgColor} text-white px-4 py-3 rounded-lg shadow-lg z-50 animate-fade-in`}
      onClick={hideToast}
    >
      {toast.message}
    </div>
  );
}
